"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Root = exports.Intro = exports.ImageWrapper = exports.Category = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("./constants");
const Root = exports.Root = (0, _mui.styled)('a')(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  height: '100%',
  textDecoration: 'none',
  maxWidth: _constants.ARTICLE_BOX_MOBILE_WIDTH,
  '&:active, &:focus, &:hover': {
    color: theme.palette.text.secondary,
    WebkitTapHighlightColor: 'transparent'
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH
  }
}));
const ImageWrapper = exports.ImageWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  aspectRatio: `${_constants.ARTICLE_BOX_DESKTOP_WIDTH} / ${_constants.ARTICLE_BOX_IMAGE_HEIGHT}`,
  borderRadius: theme.spacing(1),
  display: 'flex',
  margin: theme.spacing(0, 'auto', 1, 'auto'),
  overflow: 'hidden',
  position: 'relative',
  width: '100%',
  img: {
    height: '100%',
    left: 0,
    objectFit: 'cover',
    objectPosition: '50% 50%',
    position: 'absolute',
    top: 0,
    width: '100%'
  },
  [theme.breakpoints.up('sm')]: {
    maxWidth: _constants.ARTICLE_BOX_DESKTOP_WIDTH
  }
}));
const Category = exports.Category = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.secondary,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase'
}));
const Title = exports.Title = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  fontWeight: theme.typography.fontWeightBold,
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.h6.fontSize
  }
}));
const Intro = exports.Intro = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: '-webkit-box',
  overflow: 'hidden',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2
}));
//# sourceMappingURL=styles.js.map